// extracted by mini-css-extract-plugin
export default {"container":"detail_container__u4Use","table":"detail_table__V3CPg"};